"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsersFormComponent = void 0;
const ChartShowButtonComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/ChartShowButtonComponent");
const antd_1 = require("antd");
const React = __importStar(require("react"));
const NewUsersLineTypeComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/state/data/form/NewUsersLineTypeComponent");
const PeriodDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/common/PeriodDaysComponent");
const NewUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/NewUsersPageDataProvider");
const NewUsersPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/NewUsersPageModelProvider");
const NewUsersFormComponent = () => {
    const pageDataContext = (0, NewUsersPageDataProvider_1.useNewUsersPageDataContext)();
    const pageModelContext = (0, NewUsersPageModelProvider_1.useNewUsersPageModelContext)();
    const jsonModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const last = jsonModel.getPeriodDaysJSONModel().getLast();
    const lineType = jsonModel.getLineTypeJSONModel().getLineType();
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Row, { gutter: 12 },
            React.createElement(antd_1.Col, null,
                React.createElement(PeriodDaysComponent_1.PeriodDaysComponent, { value: last, onChange: pageModelContext.pageModelStateFns.onPeriodChanged })),
            React.createElement(antd_1.Col, null,
                React.createElement(NewUsersLineTypeComponent_1.NewUsersLineTypeComponent, { value: lineType, onChange: pageModelContext.pageModelStateFns.onLineTypeChanged }))),
        React.createElement(antd_1.Row, { className: "drawButtonRow" },
            React.createElement(antd_1.Col, { span: 24 },
                React.createElement(ChartShowButtonComponent_1.ChartShowButtonComponent, { inProgress: pageDataContext.state.status.inProgress, onClick: pageModelContext.pageModelStateFns.show, disabled: false }))));
};
exports.NewUsersFormComponent = NewUsersFormComponent;
